export const documentFontFamily = (head: HTMLElement) => {
  const fontElement = document.createElement('link')

  fontElement.setAttribute('href', 'https://fonts.googleapis.com/css?family=Lato:300,400,400i,700')
  fontElement.setAttribute('rel', 'stylesheet')

  head.appendChild(fontElement)
}
